<ng-container *ngIf="($loading | async)">
  <app-card-loader message="Loading..."></app-card-loader>

</ng-container>

<ng-container *ngIf="!($loading | async)">

  <div class="alert alert-warning d-flex align-items-center">
    <p class="mb-0">If you want to learn more about how e-mails work. Or need assistance in setting up your own e-mail address, please contact our support team.</p>
  </div>

  <ng-container *ngIf="($emailConfig | async).EmailDomain">

    <p>You are able to send e-mails from {{($emailConfig | async).EmailDomain.domain}}. If you have an e-mail address under this domain, you should set it below, and we will send all e-mails from this e-mail address.</p>

    <p>If you do not hold a {{($emailConfig | async).EmailDomain.domain}} e-mail, you should switch to "Reply To" mode</p>

  </ng-container>

</ng-container>

<div *nzModalFooter>
  <button class="btn btn-light-primary btn-sm me-2" (click)="destroyModal()">Cancel</button>
  <button
    type="button"
    (click)="confirm()"
    id="qrpay_sign_up_submit"
    class="btn btn-sm btn-theme"
  >
    <ng-container *ngIf="($submitting | async) === false">
      <span class="indicator-label">Save Settings</span>
    </ng-container>
    <ng-container *ngIf="$submitting | async">
        <span class="indicator-progress" [style.display]="'block'">
          Please wait...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
    </ng-container>
  </button>
</div>
